module.exports = __webpack_public_path__ + "img/logo.4113e7a7.png";